module.exports = __webpack_public_path__ + "static/fysioterapiasta_psykoterapiaan.64c20389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fysioterapiasta_psykoterapiaan.jpg
// module id = 814
// module chunks = 270650965324815